import * as Yup from 'yup';

export interface ICalculationVisitDetails {
  id: string;
  documentTypeId: string;
  documentNumber: string;
  firstName: string;
  middleName: string;
  lastName: string;
  gender: boolean | null;
  countryOfResidenceISO3: string;
  placeOfResidence: string;
  countryOfBirthISO3: string;
  birthDate: string;
  citizenshipISO3: string;
  checkInDate: string;
  checkInTime: string;
  checkOutDate: string;
  checkOutTime: string;
  serviceId: string;
  residenceTaxCategoryId: string;
  arrivalType: string;
  eVisitorStatus: string | null;
}

export const CalculationVisitDetailsSchema = Yup.object().shape({
  firstName: Yup.string().trim().required('Required'),
  middleName: Yup.string().nullable(),
  lastName: Yup.string().required('Required'),
  checkInDate: Yup.date().nullable(),
  checkInTime: Yup.string().nullable(),
  checkOutDate: Yup.date().nullable(),
  checkOutTime: Yup.string().nullable(),
  serviceId: Yup.string().nullable(),

  documentTypeId: Yup.string().nullable(),
  /* documentTypeId: Yup.string()
    .trim()
    .when('guestCheckIn', {
      is: (guestCheckIn: boolean) => guestCheckIn,
      then: Yup.string().required('Required'),
      otherwise: Yup.string().nullable(),
    }), */
  documentNumber: Yup.string().nullable(),
  /* documentNumber: Yup.string()
    .trim()
    .when('guestCheckIn', {
      is: (guestCheckIn: boolean) => guestCheckIn,
      then: Yup.string().required('Required'),
      otherwise: Yup.string().nullable(),
    }), */
  countryOfResidenceISO3: Yup.string().nullable(),
  /* countryOfResidenceISO3: Yup.string()
    .trim()
    .when('guestCheckIn', {
      is: (guestCheckIn: boolean) => guestCheckIn,
      then: Yup.string().required('Required'),
      otherwise: Yup.string().nullable(),
    }), */
  placeOfResidence: Yup.string().nullable(),
  /* placeOfResidence: Yup.string()
    .trim()
    .when('guestCheckIn', {
      is: (guestCheckIn: boolean) => guestCheckIn,
      then: Yup.string().required('Required'),
      otherwise: Yup.string().nullable(),
    }), */
  countryOfBirthISO3: Yup.string().nullable(),
  /* countryOfBirthISO3: Yup.string()
    .trim()
    .when('guestCheckIn', {
      is: (guestCheckIn: boolean) => guestCheckIn,
      then: Yup.string().required('Required'),
      otherwise: Yup.string().nullable(),
    }),
  birthDate: Yup.string()
    .trim()
    .when('guestCheckIn', {
      is: (guestCheckIn: boolean) => guestCheckIn,
      then: Yup.string().required('Required'),
      otherwise: Yup.string().nullable(),
    }), 
  citizenshipISO3: Yup.string().nullable(),
  /* citizenshipISO3: Yup.string()
    .trim()
    .when('guestCheckIn', {
      is: (guestCheckIn: boolean) => guestCheckIn,
      then: Yup.string().required('Required'),
      otherwise: Yup.string().nullable(),
    }), */
  citizenshipISO3: Yup.string().nullable(),
  residenceTaxCategoryId: Yup.string().nullable(),
  /* residenceTaxCategoryId: Yup.string()
    .trim()
    .when('guestCheckIn', {
      is: (guestCheckIn: boolean) => guestCheckIn,
      then: Yup.string().required('Required'),
      otherwise: Yup.string().nullable(),
    }), */
  arrivalType: Yup.string().nullable(),
  /* arrivalType: Yup.string()
    .trim()
    .when('guestCheckIn', {
      is: (guestCheckIn: boolean) => guestCheckIn,
      then: Yup.string().required('Required'),
      otherwise: Yup.string().nullable(),
    }), */
});
